import React from "react";

const Modal = ({ width, isOpen, onClose, children, type }) => {
  if (!isOpen) return null;

  return (
    <div className={`fixed inset-0 z-[1000] bg-gray-700 bg-opacity-50 flex justify-center items-center`}>
      <div className={`bg-white rounded-lg shadow-lg p-4 max-w-4xl ${width || 'w-full'} max-h-[90vh] overflow-y-auto relative`}>
        <button
          onClick={onClose}
          className="text-white bg-[#B03982] p-1 rounded-full w-12 hover:text-gray-700 float-right "
        >
          <i className="fa-sharp fa-solid fa-xmark text-1xl"></i>
        </button>

        {/* Conditional rendering based on the type */}
        <h2 className="text-xl font-bold mb-4 clear-both">
          {type === "refine" ? "" : ""}
        </h2>

        {/* Render dynamic content passed as children */}
        {children}
      </div>
    </div>
  );
};

export default Modal;
